<div class="card"> 
  <div
    class="collapse show"
    #collapse="ngbCollapse"
    [(ngbCollapse)]="isCollapsed"
  >
    <div
      class="card-body social-status filter-cards-view"
      *ngFor="let activity of history"
    >
      <div class="d-flex">
        <img
          class="img-50 rounded-circle m-r-15"
          src="assets/images/user/3.jpg"
          alt=""
        />
        <div class="flex-grow-1">
          <a >
            <span class="f-w-600 d-block">{{ activity.changesFrom }}</span>
          </a>
          <p>
            {{ activity.changes }}
          </p>
          <span class="light-span">{{ activity.changesWhen  | daysAgo }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
